import PropTypes from 'prop-types';

function PlaceholderInput(props) {
  const { handlePlaceholderInput } = props;

  return (
    <div>
      <label>Placeholder</label>
      <input id="#placeholder" className="form-control" onChange={handlePlaceholderInput} />
      <hr />
    </div>
  );
}

PlaceholderInput.propTypes = {
  handlePlaceholderInput: PropTypes.func,
};

export default PlaceholderInput;
